module.exports = __webpack_public_path__ + "img/2_22.db96b1e8.png";